<template>
    <div id="compare"
         v-on:mouseover="mouseovercomparisonList"
         v-on:mouseleave="mouseleavecomparisonList">
        <div class="items shadow-radius" v-if="showComparisonList">
            <ul>
                <li v-for="product in value" :key="product.actualProductId">
                    <span class="avafont-close" @click="removeProduct(product.actualProductId)"></span>
                    <a :href="'/Product/Details/' + product.actualProductId">
                        <img :src="'https://asset.avajang.com/Product/' + product.imageUri"
                             class="img-responsive matchHeight" />
                        <img src="../../../../wwwroot/img/no-image.jpg"
                             class="img-responsive matchHeight"
                             v-if="!product.imageUri" />
                        <h6 class="matchHeight2">
                            {{ product.persianName | truncate(60) }}
                        </h6>
                    </a>
                </li>
            </ul>
        </div>
        <div class="buttons">
            <a :href="compareURl" class="compare-btn" target="_blank">مقایسه({{ (value.length).toLocaleString() | toPersianNumber }} محصول)</a>
            <button class="close-all" @click="clearComparisonList">
                <span class="avafont-close"></span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ComparisonList',
        props: {
            value: {
                type: Array,
                default: []
            },
            limitCount: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                showComparisonList: false,
                compareListItems: [],
                compareURl: '',
            };
        },
        mounted() {
            //setCompareURL
            this.value.forEach((element) => {
                this.compareListItems += `&item=${element.actualProductId}`;
            });
            this.compareURl = '/Product/Compare?category=' + this.$route.params.id + (this.compareListItems ? this.compareListItems : '');
        },
        methods: {
            removeProduct(productId) {
                this.$emit('onRemoveItem', productId);
            },
            clearComparisonList() {
                this.$emit('onClearComparisonList');
            },
            mouseovercomparisonList: function () {
                this.showComparisonList = true;
            },
            mouseleavecomparisonList: function () {
                this.showComparisonList = false;
            },
        },
        watch: {
            //setCompareURL
            value: {
                handler(value) {
                    this.compareListItems = [];
                    this.value.forEach((element) => {
                        this.compareListItems += `&item=${element.actualProductId}`;
                    });
                    this.compareURl = '/Product/Compare?category=' + this.$route.params.id + (this.compareListItems ? this.compareListItems : '');
                },
                deep: true
            },
        }
    };
</script>
